let offlineActorUserId: string | null = null;

export function setOfflineActorUserId(userId: string | null): void {
  offlineActorUserId = userId;
}

export function getOfflineActorUserId(): string | null {
  return offlineActorUserId;
}
